/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyName: NonNullable<unknown> }} Home_Services_SubtitleInputs */

const en_home_services_subtitle = /** @type {(inputs: Home_Services_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your ${i?.companyName} coverage includes access to value-added partner services at no additional cost.`)
};

const fr_home_services_subtitle = /** @type {(inputs: Home_Services_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votre couverture ${i?.companyName} inclut l'accès à des services partenaires à valeur ajoutée sans frais supplémentaires.`)
};

/**
* | output |
* | --- |
* | "Your {companyName} coverage includes access to value-added partner services at no additional cost." |
*
* @param {Home_Services_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_services_subtitle = /** @type {((inputs: Home_Services_SubtitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Services_SubtitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_services_subtitle(inputs)
	return fr_home_services_subtitle(inputs)
});